// Per-chatbot chat history (Monitor → Chat History tab).
// Route /chatbots/:id/history. Shows every visitor thread for this one
// bot — bot conversations and live-agent sessions — split into Guests /
// Staff sub-tabs. Gated by conversations.view (route reg in App.tsx).

import { useParams, Link } from "wouter";
import { useQuery } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { HistoryView } from "@/components/history-view";
import type { Chatbot } from "@shared/schema";

export default function ChatbotHistoryPage() {
  const params = useParams();
  const chatbotId = params.id!;
  const { data: chatbot } = useQuery<Chatbot>({ queryKey: ["/api/chatbots", chatbotId] });

  return (
    <div className="p-6 max-w-5xl mx-auto space-y-6">
      <div className="flex items-center gap-3">
        <Link href={`/chatbots/${chatbotId}`}>
          <Button variant="ghost" size="sm" data-testid="link-back-to-bot">
            <ArrowLeft className="w-4 h-4 mr-1" /> Back to bot
          </Button>
        </Link>
      </div>
      <div>
        <h1 className="text-2xl font-semibold tracking-tight" data-testid="text-chatbot-history-title">Chat History</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Complete history for {chatbot?.name || "this bot"} — bot conversations and live-agent sessions.
        </p>
      </div>
      <HistoryView listKey={["/api/chatbots", chatbotId, "history"]} showBotName={false} />
    </div>
  );
}
